let uploadedIds = []; // ✅ 必须加上 let，保证是局部变量

/** 退货页未引入 public-popup.js 时补齐，避免 submitRefund 报 showErrorPopup is not a function */
if (typeof window.showErrorPopup !== "function") {
  window.showErrorPopup = function (message) {
    var exist = document.querySelector(".error-popup");
    if (exist) exist.remove();

    var div = document.createElement("div");
    div.className = "error-popup";
    div.setAttribute(
      "style",
      "position:fixed;z-index:999999;inset:0;font-family:sans-serif;"
    );
    div.innerHTML =
      '<div class="error-popup-mask" style="position:absolute;inset:0;background:rgba(0,0,0,.5);"></div>' +
      '<div class="error-popup-box" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;width:80%;max-width:360px;padding:20px;border-radius:10px;text-align:center;">' +
      '<div class="error-title" style="font-size:18px;font-weight:bold;margin-bottom:12px;color:#d8000c;">Error</div>' +
      '<div class="error-message" style="font-size:15px;margin-bottom:20px;color:#333;line-height:1.5;"></div>' +
      '<button type="button" class="error-close-btn" style="background:#d8000c;color:#fff;border:0;padding:8px 24px;border-radius:6px;cursor:pointer;">OK</button>' +
      "</div>";

    var msgEl = div.querySelector(".error-message");
    if (msgEl) msgEl.textContent = message || "Something went wrong";
    document.body.appendChild(div);

    var close = function () {
      div.remove();
    };
    var closeBtn = div.querySelector(".error-close-btn");
    var mask = div.querySelector(".error-popup-mask");
    if (closeBtn) closeBtn.onclick = close;
    if (mask) mask.onclick = close;
  };
}

// ====== 增加的逻辑：用于标记当前是否选择了 used ======
document.addEventListener("DOMContentLoaded", function () {
  // --------- 渲染商品 ----------
  try {
    // 从缓存读取
    const product = JSON.parse(
      sessionStorage.getItem("order_line_product") || "{}"
    );
    const variant = JSON.parse(
      sessionStorage.getItem("order_line_variant") || "{}"
    );
    const orderName = sessionStorage.getItem("order_name");
    const createdAt = sessionStorage.getItem("order_created_at");
    const orderLineQuantity = sessionStorage.getItem("order_line_quantity");
    // 渲染订单头部
    const orderTop = document.querySelector(".order-top-cen");
    if (orderTop) {
      orderTop.innerHTML = `
            <h2>Order ID: ${orderName || ""}</h2>
            <p class="order-date">Date: ${
              createdAt ? new Date(createdAt).toLocaleDateString("en-US") : ""
            }</p>
          `;
    }
    // 如果缓存为空则提示
    if (!product?.title || !variant?.title) {
      console.warn("⚠️ 没有找到缓存的 product / variant 信息");
      return;
    }

    console.log("📦 当前退款商品数据：", { product, variant });

    // 构建 HTML
    const html = `
    <div class="flex product-items gap-4 mb-6 cen">
      <img src="${variant.image?.url || product.featuredImage?.url || ""}" 
          alt="${product.title || ""}" 
          class="w-20 h-20 pic-left rounded" />

      <div class="product-item-right">
        <p class="text-title font-medium">${product.title || ""}</p>
        <p class="product-variant">${variant.title || ""}</p>
        <p class="text-price">
          ${variant.price ? `$${variant.price}` : ""}
          ${
            variant.compareAtPrice
              ? `<span class="text-gray-400 line-through ml-2">$${variant.compareAtPrice}</span>`
              : ""
          }
          <span class="line_qua">X ${orderLineQuantity || ""}</span>
        </p>
      </div>
    </div>`;

    // 插入到容器中
    const msgBox = document.getElementById("product-message");
    if (msgBox) {
      msgBox.innerHTML = html;
    } else {
      console.warn("⚠️ 未找到 #product-message 容器");
    }
  } catch (err) {
    console.error("❌ 渲染退款商品信息出错：", err);
  }
  // --------- 工具函数 ----------
  const orderId = window.getQueryParam("order_id");
  const variantId = window.getQueryParam("variant_id");
  // 遍历获取点击的产品内容
  document.querySelectorAll(".return-option").forEach(function (option) {
    option.addEventListener("click", function () {
      const type = this.dataset.type; // refund / return_refund / exchange
      let requestType;
      let targetPage;

      if (type === "refund") {
        requestType = 1;
        targetPage = "/pages/return-only";
      } else if (type === "return_refund") {
        requestType = 2;
        targetPage = "/pages/coustom-return-no-use-apply-waybill";
      } else if (type === "exchange") {
        // 🚫 不跳转，显示提示弹窗
        showExchangePopup();
        return; // 阻止后续执行
      }

      // 正常跳转逻辑
      window.location.href = `${targetPage}?order_id=${orderId}&variant_id=${variantId}&request_type=${requestType}`;
    });
  });

  // --------- radio 按钮选择 ----------
  window.radio_btn = function () {
    document
      .querySelectorAll(".choose-information .options")
      .forEach((group) => {
        if (group.dataset._init === "true") return; // 防止重复绑定
        group.dataset._init = "true";

        group.addEventListener("click", (e) => {
          const btn = e.target.closest(".return-method-btn");
          if (!btn) return;
          group
            .querySelectorAll(".return-method-btn")
            .forEach((b) => b.classList.remove("selected"));
          btn.classList.add("selected");
          console.log(
            "Group:",
            group.dataset.group,
            "Value:",
            btn.dataset.value
          );
        });
      });
  };
  window.radio_btn();
  // 判断是否是退换货页面的已使用选择
  // const requestType = window.getQueryParam("request_type") || "1";
  // const emptyHeight = document.querySelector(".return-request-types-cen .empty-height");
  // let printLabel = '退款';
  // if (requestType === "1"){
  //   printLabel = '退款';
  // }
  // initRefundSubmit();
  const requestType = window.getQueryParam("request_type") || "1";
  const emptyHeight = document.querySelector(
    ".return-request-types-cen .empty-height"
  );
  let printLabel = "退款";

  if (requestType === "1") {
    printLabel = "退款";
    const isUsedSelectedRef = { value: false };

    const statusButtons = document.querySelectorAll(
      ".options[data-group='status'] .return-method-btn"
    );
    statusButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.getAttribute("data-value");
        isUsedSelectedRef.value = value === "used";

        const tipEl = document.querySelector(".select-img--tip");
        if (tipEl) {
          tipEl.textContent =
            "Additional details can help us efficiently approve your request";
          tipEl.style.color = "#666";
        }
      });
    });
    // 初始化上传
    const getUploadedIds = initFileUpload();
    const reasonInput = document.getElementById("reason-name");
    console.log("获取的信息", getUploadedIds, isUsedSelectedRef, reasonInput);
    reasonInput?.addEventListener("input", () => {
      console.log("监听原因输入");
      if (reasonInput.value) {
        const tip = document.querySelector(".choose-reason-con .error-text");
        if (tip) {
          tip.textContent = "";
          tip.style.display = "none";
        }
      }
    });

    // 初始化提交
    const refundSubmit =
      typeof initRefundSubmit === "function"
        ? initRefundSubmit(getUploadedIds, isUsedSelectedRef)
        : null;

    const updateUploadTip = refundSubmit?.updateUploadTip || (() => {});

    // const { updateUploadTip } = initRefundSubmit(getUploadedIds, isUsedSelectedRef);

    // 让上传逻辑在上传成功或删除时调用 updateUploadTip()

    // printLabel = '退款';

    // let isUsedSelected = false;

    // // 监听「商品状态」按钮（只有退款时启用必填）
    // const statusButtons = document.querySelectorAll(".options[data-group='status'] .return-method-btn");
    // statusButtons.forEach(btn => {
    //   btn.addEventListener("click", () => {
    //     const value = btn.getAttribute("data-value");
    //     isUsedSelected = (value === "used"); // 记录状态选择
    //     console.log('获取上传的信息',isUsedSelected);
    //     // 如果取消了 used，恢复提示状态
    //     const tipEl = document.querySelector(".select-img--tip");
    //     if (tipEl) {
    //       tipEl.textContent = "Additional details can help us efficiently approve your request";
    //       tipEl.style.color = "#666";
    //     }
    //   });
    // });

    // // ⚙️ 初始化上传逻辑
    // const getUploadedIds = initFileUpload();

    // // ✅ 最后只在这里调用一次
    // initRefundSubmit(getUploadedIds, { value: isUsedSelected });
    // // ⚙️ 在提交按钮点击时进行校验
    // const confirmBtn = document.getElementById("confirm-refund");
    // if (confirmBtn) {
    //   confirmBtn.addEventListener("click", (e) => {
    //     // 如果是 used 且没上传文件，则提示错误
    //     if (isUsedSelected) {
    //       const uploadedIds = getUploadedIds(); // 获取当前上传的文件
    //       const tipEl = document.querySelector(".select-img--tip");
    //       if (uploadedIds.length === 0) {
    //         e.preventDefault();
    //         if (tipEl) {
    //           tipEl.textContent = "Please upload at least one image or video";
    //           tipEl.style.color = "red";
    //           tipEl.style.display = "block";
    //         }
    //         // 滚动到上传区域
    //         document.querySelector(".pic-upload")?.scrollIntoView({ behavior: "smooth", block: "center" });
    //         return;
    //       } else {
    //         // 有上传则恢复默认提示
    //         if (tipEl) {
    //           tipEl.textContent = "Additional details can help us efficiently approve your request";
    //           tipEl.style.color = "#666";
    //         }
    //       }
    //     }
    //   });
    // }
  }
  if (requestType === "3") {
    printLabel = "换货";
  }
  if (requestType === "2") {
    printLabel = "退货退款";

    const isUsedSelectedRef = { value: false };

    const statusButtons = document.querySelectorAll(
      ".options[data-group='status'] .return-method-btn"
    );
    const formSections = document.querySelectorAll(
      ".return-address, .logistics-information, .form-section:not(.product-status)"
    );
    const refundWarning = document.getElementById("refund-warning");
    const confirmBtn = document.getElementById("confirm-refund");
    statusButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.getAttribute("data-value");
        console.log("选择的是哪个", value);
        if (value === "used") {
          // 隐藏下面所有表单
          formSections.forEach((sec) => sec.classList.add("hidden"));
          // 显示警告提示
          refundWarning.classList.remove("hidden");
          // 改按钮文案
          if (confirmBtn) {
            confirmBtn.textContent = "Apply For Refund";
            confirmBtn.addEventListener("click", () => {
              // 获取当前 URL 参数
              const urlParams = new URLSearchParams(window.location.search);

              // 把 request_type 改为 1（无论原来有没有）
              urlParams.set("request_type", "1");

              // 拼接到新的页面
              window.location.href = `/pages/return-only?${urlParams.toString()}`;
            });
          }
        } else {
          // 选择 unused 时恢复原状
          formSections.forEach((sec) => sec.classList.remove("hidden"));
          refundWarning.classList.add("hidden");
          if (confirmBtn) confirmBtn.textContent = "Submit";
        }
        // isUsedSelectedRef.value = (value === "used");

        // const tipEl = document.querySelector(".select-img--tip");
        // if (tipEl) { tipEl.textContent = "Additional details can help us efficiently approve your request"; tipEl.style.color = "#666"; }
      });
    });
    // 初始化上传
    const getUploadedIds = initFileUpload();
    const reasonInput = document.getElementById("reason-name");
    console.log("获取的信息", getUploadedIds, isUsedSelectedRef, reasonInput);
    reasonInput?.addEventListener("input", () => {
      console.log("监听原因输入");
      if (reasonInput.value) {
        const tip = document.querySelector(".choose-reason-con .error-text");
        if (tip) {
          tip.textContent = "";
          tip.style.display = "none";
        }
      }
    });

    // 初始化提交
    const refundSubmit =
      typeof initRefundSubmit === "function"
        ? initRefundSubmit(getUploadedIds, isUsedSelectedRef)
        : null;

    const updateUploadTip = refundSubmit?.updateUploadTip || (() => {});

    // 隐藏 empty-height
    if (emptyHeight) emptyHeight.classList.add("hidden");

    // const statusButtons = document.querySelectorAll(".options[data-group='status'] .return-method-btn");
    // const formSections = document.querySelectorAll(
    //   ".return-address, .logistics-information, .form-section:not(.product-status)"
    // );
    // const refundWarning = document.getElementById("refund-warning");
    // const confirmBtn = document.getElementById("confirm-refund");

    // statusButtons.forEach(btn => {
    //   btn.addEventListener("click", () => {
    //     const value = btn.getAttribute("data-value");

    //     if (value === "used") {
    //       // 隐藏下面所有表单
    //       formSections.forEach(sec => sec.classList.add("hidden"));
    //       // 显示警告提示
    //       refundWarning.classList.remove("hidden");
    //       // 改按钮文案
    //       if (confirmBtn) confirmBtn.textContent = "Apply For Refund";
    //     } else {
    //       // 选择 unused 时恢复原状
    //       formSections.forEach(sec => sec.classList.remove("hidden"));
    //       refundWarning.classList.add("hidden");
    //       if (confirmBtn) confirmBtn.textContent = "Submit";
    //     }
    //   });
    // });
  } else {
    // 不是 2 的情况，显示 empty-height
    if (emptyHeight) emptyHeight.classList.remove("hidden");
  }

  // 选择退货方式
  const methodButtons = document.querySelectorAll(
    ".return-method-btn[data-method]"
  );
  const returnAddress = document.querySelector(".return-address");
  const logisticsInfo = document.querySelector(".logistics-information");

  // 初始化：默认隐藏
  // if (returnAddress) returnAddress.classList.add("hidden");
  // if (logisticsInfo) logisticsInfo.classList.add("hidden");

  methodButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      // 移除所有按钮的选中状态
      methodButtons.forEach((b) => b.classList.remove("selected"));
      this.classList.add("selected");

      const method = this.dataset.method;

      if (method === "self") {
        // 自己寄 → 显示两块
        returnAddress?.classList.remove("hidden");
        logisticsInfo?.classList.remove("hidden");
        // ===== 在这里调用接口 =====
        fetch("https://plugin.kriyya.com/api/klaiyi/rma/config", {
          method: "GET",
          headers: {
            Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
          },
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
          .then(({ ok, data }) => {
            console.log(
              "config 接口返回:",
              data.data,
              data.data.logistics_company
            );
            if (!ok) {
              alert("获取配置失败: " + (data.message || "未知错误"));
            } else {
              // TODO: 在这里渲染到页面
              // 1. 渲染物流公司到下拉框
              const carrierSelect = document.getElementById("shipping-carrier");
              if (carrierSelect && Array.isArray(data.data.logistics_company)) {
                // 清空原有选项
                carrierSelect.innerHTML = ``;
                // 追加新的 option
                data.data.logistics_company.forEach((company) => {
                  const opt = document.createElement("option");
                  opt.value = company.toLowerCase();
                  opt.textContent = company;
                  carrierSelect.appendChild(opt);
                });
              }

              // 2. 渲染退货地址到 copy-text 里的 <p>
              const copyTextP = document.querySelector(".copy-text p");
              const receiver_name = document.querySelector(
                ".return-address-cen-top strong"
              );
              const receiver_phone = document.querySelector(
                ".return-address-cen-top span"
              );
              if (copyTextP && data.data.return_address) {
                copyTextP.textContent = data.data.return_address;
              }
              if (receiver_name && data.data.recipient_name) {
                receiver_name.textContent = data.data.recipient_name;
              }
              if (receiver_phone && data.data.recipient_phone) {
                receiver_phone.textContent = data.data.recipient_phone;
              }
            }
          })
          .catch((err) => {
            console.error("请求 config 接口异常:", err);
            alert("网络错误，请稍后重试");
          });
      } else {
        // 申请运单 → 隐藏两块
        returnAddress?.classList.add("hidden");
        logisticsInfo?.classList.add("hidden");
      }
    });
  });

  // --------- 文件上传预览 + 上传 ----------
  // 上传成功后的 ID 数组

  // --------- 文件上传预览 + 调用 uploads 接口 ----------
  function initFileUpload() {
    console.log("进了文件上传");
    const UPLOAD_TOKEN = "6JXquydq6hZG4aJyN8A5";
    const input = document.getElementById("refund-files");
    const previewArea = document.getElementById("preview-area");
    const helpText = document.querySelector(".upload-camera-btn .help-text");
    const uploadLabel = document.querySelector(".upload-camera-btn"); // 上传入口
    if (!input || !previewArea || !helpText || !uploadLabel) return;

    const maxFiles = 8;

    // ✅ 获取或创建提示元素（放在 .pic-upload 外部）
    const formSection = document.querySelector(".pic-upload");
    let tipEl = document.querySelector(".select-img--tip");
    if (!tipEl) {
      tipEl = document.createElement("div");
      tipEl.className = "select-img--tip";
      tipEl.textContent =
        "Additional details can help us efficiently approve your request";
      // 插在 .pic-upload 之后，作为兄弟元素
      formSection.parentNode.insertBefore(tipEl, formSection.nextSibling);
    }

    // ✅ 更新文字 + 提示显示逻辑
    function updateUploadText() {
      helpText.textContent = `${uploadedIds.length}/${maxFiles}`;
      // 超出数量时显示提示
      tipEl.style.display = uploadedIds.length >= maxFiles ? "block" : "none";
      // 上传入口始终显示
      uploadLabel.style.display = "flex";
    }

    // ✅ 点击上传入口时检测数量
    uploadLabel.addEventListener("click", (e) => {
      if (uploadedIds.length >= maxFiles) {
        e.preventDefault(); // 阻止打开文件选择框
        showMessage("You can upload up to 8 photos or videos only");
      }
    });

    // ✅ 消息提示函数（替代 alert）
    function showMessage(msg) {
      let msgEl = document.querySelector(".upload-limit-message");
      if (!msgEl) {
        msgEl = document.createElement("div");
        msgEl.className = "upload-limit-message";
        document.body.appendChild(msgEl);
      }
      msgEl.textContent = msg;
      msgEl.classList.add("show");
      setTimeout(() => msgEl.classList.remove("show"), 2500);
    }

    // ✅ 创建 loading 占位符
    function createPlaceholder() {
      const item = document.createElement("div");
      item.className = "preview-item loading";
      item.innerHTML = `<div class="preview-thumb"><span class="loading-bar"></span></div>`;
      previewArea.appendChild(item);
      return item;
    }

    // ✅ 文件上传逻辑（支持图片 + 视频）
    input.addEventListener("change", async function (e) {
      console.log("点击上传图片");
      const files = Array.from(e.target.files || []);
      if (!files.length) return;

      if (uploadedIds.length >= maxFiles) {
        showMessage("You can upload up to 8 photos or videos only");
        input.value = "";
        return;
      }

      if (uploadedIds.length + files.length > maxFiles) {
        showMessage(
          `You can only upload ${maxFiles - uploadedIds.length} more file(s)`
        );
        input.value = "";
        return;
      }

      const placeholders = files.map((file) => ({
        file,
        placeholder: createPlaceholder(),
      }));

      const form = new FormData();
      files.forEach((f) => form.append("files[]", f));

      try {
        const res = await fetch(
          "https://plugin.kriyya.com/api/klaiyi/rma/uploads",
          {
            method: "POST",
            headers: { Authorization: "Bearer " + UPLOAD_TOKEN },
            body: form,
          }
        );

        const data = await res.json();
        const returned = Array.isArray(data.data)
          ? data.data
          : data.data?.files || [];

        returned.forEach((ret, idx) => {
          const p = placeholders[idx];
          if (!p) return;

          let fileInfo =
            ret?.id || ret?.imageId || ret?.media_id || ret?.path || ret;
          if (!fileInfo) {
            p.placeholder.remove();
            return;
          }

          uploadedIds.push(fileInfo);
          updateUploadText();
          if (window.updateUploadTip) updateUploadTip();
          // ✅ 清除上传报错
          clearErrorMessage(".form-section-upload-pic");
          const file = p.file;
          const url = URL.createObjectURL(file);

          p.placeholder.classList.remove("loading");

          // ✅ 图片与视频分开预览
          if (file.type.startsWith("image/")) {
            p.placeholder.innerHTML = `
              <div class="preview-thumb">
                <img src="${url}" alt="preview">
                <button type="button" class="remove-btn" aria-label="remove">×</button>
              </div>
            `;
          } else if (file.type.startsWith("video/")) {
            p.placeholder.innerHTML = `
              <div class="preview-thumb video">
                <video src="${url}" muted playsinline preload="metadata"></video>
                <button type="button" class="remove-btn" aria-label="remove">×</button>
              </div>
            `;
          }

          // ✅ 删除逻辑
          p.placeholder
            .querySelector(".remove-btn")
            .addEventListener("click", () => {
              p.placeholder.remove();
              uploadedIds = uploadedIds.filter((x) => x !== fileInfo);
              updateUploadText();
              if (window.updateUploadTip) updateUploadTip();
            });

          // updateUploadText();
        });
      } catch (err) {
        console.error("文件上传异常:", err);
        placeholders.forEach((p) => p.placeholder.remove());
        showMessage("Network error, upload failed");
      } finally {
        input.value = "";
      }
    });

    // ✅ 初始化状态
    // updateUploadText();

    // ✅ 提示样式
    const style = document.createElement("style");
    style.textContent = `
      .upload-limit-message {
        position: fixed;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0,0,0,0.85);
        color: #fff;
        padding: 10px 16px;
        border-radius: 6px;
        font-size: 14px;
        opacity: 0;
        transition: opacity .3s ease;
        pointer-events: none;
        z-index: 9999;
      }
      .upload-limit-message.show {
        opacity: 1;
      }
      .select-img--tip {
        margin-top: 10px;
        font-size: 13px;
        color: #666;
        display: none;
      }
      .preview-item video {
        width: 100%;
        height: auto;
        border-radius: 6px;
        object-fit: cover;
      }
    `;
    // ✅ 提示样式 ...
    document.head.appendChild(style);

    // ✅ 返回一个函数，用于获取当前上传 ID 数组
    return function getUploadedIds() {
      return uploadedIds;
    };

    // document.head.appendChild(style);

    // return () => uploadedIds;
  }

  // 为输入框添加输入监听事件
  const trackingInput = document.querySelector(
    ".logistics-information-cen .information-enter"
  );
  if (trackingInput) {
    trackingInput.addEventListener("input", function () {
      if (this.value.trim()) {
        // 输入框有值时清除错误提示
        clearErrorMessage(".logistics-information-cen");
      }
    });
  }
  const confirmBtn = document.getElementById("confirm-refund");
  const popup = document.querySelector(".sure-popup");

  const popupTitle = popup.querySelector(".popup-title");
  const popupContent = popup.querySelector(".sure-popup-main-word");
  const btnNo = popup.querySelector(".sure_popup-btn-left");
  const btnYes = popup.querySelector(".sure_popup-btn-right");
  const btnClose = popup.querySelector(".icon-Close");
  // --------- 提交 ----------
  // --------- 提交弹窗控制 ----------
  function initRefundSubmit(getUploadedIds, isUsedSelectedRef) {
    const confirmBtn = document.getElementById("confirm-refund");
    if (!confirmBtn) return;

    confirmBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let hasError = false;

      const itemStatus =
        document.querySelector(
          '.options[data-group="status"] .return-method-btn.selected'
        )?.dataset.value || "";
      const reasonName = document.getElementById("reason-name")?.value || "";
      const subReasonName =
        document.getElementById("sub-reason-name")?.value || "";
      const uploadedIds = getUploadedIds ? getUploadedIds() : [];
      const tipEl = document.querySelector(".select-img--tip");

      // 1️⃣ 验证 Item Status
      if (!itemStatus) {
        showErrorMessage(".choose-information", "Please select Item Status");
        hasError = true;
      }

      // 2️⃣ 验证原因
      if (!reasonName || !subReasonName) {
        showErrorMessage(".choose-reason-con", "Please select a return reason");
        hasError = true;
      }

      // 3️⃣ 验证如果选择自己寄快递的话，需要验证是否填写单号
      const selectedBtn = document.querySelector(
        ".post-type .return-method-btn.selected"
      );

      const choose_method = selectedBtn?.dataset.method || "";

      // 获取 tracking input
      const trackingInput = document.querySelector(
        ".logistics-information-cen .information-enter"
      );

      const trackingValue = trackingInput?.value.trim() || "";
      console.log(
        "点击提交01",
        uploadedIds.length,
        selectedBtn,
        choose_method,
        trackingValue
      );
      //  ✅ 新增：self 需要填写 tracking number
      if (choose_method == "self" && !trackingValue) {
        showErrorMessage(
          ".logistics-information-cen",
          "Please enter tracking number"
        );

        trackingInput?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        trackingInput?.focus(); // ✅ UX 更好

        hasError = true;
      }
      // 4️⃣ 验证上传文件
      if (uploadedIds.length == 0) {
        console.log("获取提示信息结构", tipEl);
        showErrorMessage(
          ".form-section-upload-pic",
          "Please upload at least one image or video"
        );
        hasError = true;
        document
          .querySelector(".pic-upload")
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
        hasError = true;
      }

      if (hasError) return;

      /* ✅ 统一使用 SurePopup */
      window.SurePopup?.open({
        title: "Confirm Submission",
        text: `We'll handle your submission within 24 hours.<br>
             For any questions, contact us at 
             <a href="mailto:Klaiyi@klaiyihair.com" class="support-email">Klaiyi@klaiyihair.com</a>`,

        leftText: "Yes",
        rightText: "No",
        zIndex: 181,

        onCancel() {
          // 什么都不做，自动 close
        },

        async onConfirm() {
          try {
            await submitRefund();
          } catch (err) {
            console.error("submitRefund error:", err);
            alert("Submission failed, please try again later");
          }
        },
      });
    });

    // ✅ 上传提示更新函数保持不变
    function updateUploadTip() {
      const uploaded = getUploadedIds();
      const tipEl = document.querySelector(".select-img--tip");
      if (!tipEl) return;

      if (isUsedSelectedRef.value && uploaded.length === 0) {
        tipEl.textContent = "Please upload at least one image or video";
        tipEl.style.color = "red";
        tipEl.style.display = "block";
      } else {
        tipEl.textContent =
          "Additional details can help us efficiently approve your request";
        tipEl.style.color = "#666";
        tipEl.style.display = "block";
      }
    }

    return { updateUploadTip };
  }

  // // --------- 提交弹窗控制 ----------
  // function initRefundSubmit(getUploadedIds, isUsedSelectedRef) {
  //   const confirmBtn = document.getElementById("confirm-refund");
  //   const popup = document.querySelector(".sure-popup");
  //   const popupCover = document.querySelector(".sure-popup .window-cover");
  //   if (!confirmBtn || !popup) return;

  //   const popupTitle =
  //     popup.querySelector(".pop_title span") ||
  //     popup.querySelector(".popup-title");
  //   const popupContent = popup.querySelector(".sure-popup-main-word");
  //   const btnNo = popup.querySelector(".sure_popup-btn-left");
  //   const btnYes = popup.querySelector(".sure_popup-btn-right");
  //   const btnClose = popup.querySelector(".icon-Close");

  //   // ✅ 点击 Submit 按钮 -> 先执行非空验证
  //   confirmBtn.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     let hasError = false;

  //     const itemStatus =
  //       document.querySelector(
  //         '.options[data-group="status"] .return-method-btn.selected'
  //       )?.dataset.value || "";
  //     const reasonName = document.getElementById("reason-name")?.value || "";
  //     const subReasonName =
  //       document.getElementById("sub-reason-name")?.value || "";
  //     const uploadedIds = getUploadedIds ? getUploadedIds() : [];
  //     const tipEl = document.querySelector(".select-img--tip");

  //     // 1️⃣ 验证 Item Status
  //     if (!itemStatus) {
  //       showErrorMessage(".choose-information", "Please select Item Status");
  //       hasError = true;
  //     }

  //     // 2️⃣ 验证原因
  //     if (!reasonName || !subReasonName) {
  //       showErrorMessage(".choose-reason-con", "Please select a return reason");
  //       hasError = true;
  //     }

  //     // 3️⃣ 验证上传文件（used 必填）
  //     if (
  //       isUsedSelectedRef &&
  //       isUsedSelectedRef.value &&
  //       uploadedIds.length === 0
  //     ) {
  //       if (tipEl) {
  //         tipEl.textContent = "Please upload at least one image or video";
  //         tipEl.style.color = "red";
  //         tipEl.style.display = "block";
  //       }
  //       document
  //         .querySelector(".pic-upload")
  //         ?.scrollIntoView({ behavior: "smooth", block: "center" });
  //       hasError = true;
  //     }

  //     if (hasError) return;

  //     // ✅ 显示弹窗
  //     // ✅ 通过验证 -> 显示弹窗
  //     if (popupTitle)
  //       popupTitle.textContent = "Are you sure to submit the request?";
  //     if (popupContent) {
  //       popupContent.innerHTML = `
  //           We'll handle your submission within 24 hours.
  //           For any questions, contact us at
  //           <span class="support-email">Klaiyi@klaiyihair.com</span>
  //         `;
  //     }
  //     if (btnNo) btnNo.textContent = "no";
  //     if (btnYes) btnYes.textContent = "yes";
  //     popup.classList.remove("none");
  //     popupCover.style.display = "block";

  //     // ❌ 点击 no / 关闭
  //     if (btnNo) {
  //       btnNo.addEventListener("click", () => {
  //         popup.classList.add("none");
  //         popupCover.style.display = "none";
  //       });
  //     }
  //     if (btnClose) {
  //       btnClose.addEventListener("click", () => {
  //         popup.classList.add("none");
  //         popupCover.style.display = "none";
  //       });
  //     }

  //     // ✅ 点击 yes -> 执行提交（不再验证）
  //     if (btnYes) {
  //       btnYes.addEventListener("click", async function () {
  //         popup.classList.add("none");
  //         popupCover.style.display = "none"; // ✅ 同时关闭遮罩
  //         try {
  //           await submitRefund();
  //         } catch (err) {
  //           console.error("submitRefund 报错:", err);
  //           alert("Submission failed, please try again later");
  //         }
  //       });
  //     }
  //   });

  //   // ✅ 定义更新上传提示的函数（供外部调用）
  //   function updateUploadTip() {
  //     const uploaded = getUploadedIds(); // ✅ 调用函数获取当前上传 ID 数组
  //     const tipEl = document.querySelector(".select-img--tip");
  //     if (!tipEl) return;

  //     if (isUsedSelectedRef.value && uploaded.length === 0) {
  //       tipEl.textContent = "Please upload at least one image or video";
  //       tipEl.style.color = "red";
  //       tipEl.style.display = "block";
  //     } else {
  //       tipEl.textContent =
  //         "Additional details can help us efficiently approve your request";
  //       tipEl.style.color = "#666";
  //       tipEl.style.display = "block";
  //     }
  //   }

  //   // ✅ 返回这个函数，给上传逻辑调用
  //   return { updateUploadTip };
  // }

  // --------- 提交 RMA 信息（必须是 async） ----------
  async function submitRefund() {
    // 取数据（保持你原来的逻辑）
    // const orderData = JSON.parse(orderEl.dataset.json || "{}");
    const customerId = window.customerData?.email || "";
    const orderItemId = window.getQueryParam("order_id");

    const selectedStatusBtn = document.querySelector(
      '.options[data-group="status"] .return-method-btn.selected'
    );
    const itemStatus = selectedStatusBtn ? selectedStatusBtn.dataset.value : "";

    let hasError = false;
    // 一级原因
    const reasonName = document.getElementById("reason-name")?.value || "";
    // 二级原因
    const subReasonName =
      document.getElementById("sub-reason-name")?.value || "";
    const comment = document.getElementById("refund-description")?.value || "";

    const selectedMethodBtn = document.querySelector(
      ".options .return-method-btn[data-method].selected"
    );
    const isApplyShippingLabel =
      selectedMethodBtn && selectedMethodBtn.dataset.method === "label"
        ? "1"
        : "0";

    // 获取物流信息
    const carrierSelect = document.getElementById("shipping-carrier");
    const carrierValue = carrierSelect ? carrierSelect.value : "";
    const trackingInput = document.querySelector(
      ".logistics-information-cen .information-enter"
    );
    const trackingValue = trackingInput ? trackingInput.value.trim() : "";
    // itemStatus 需确保在你的代码中定义了
    console.log("获取选中的原因", reasonName, subReasonName);
    // if (!itemStatus) {
    //   console.log('没有选择是否使用');
    //   showErrorMessage(".choose-information", "Please select Item Status");
    //   hasError = true;
    // }

    // if (!reasonName) {
    //   showErrorMessage(".choose-reason-con", "Please select a return reason");
    //   hasError = true;
    // }

    // // 如果存在错误，阻止后续逻辑
    // if (hasError) return;

    // 获取已上传图片 id
    let attachmentIds = "";
    // const ids = initFileUpload ? initFileUpload() : [];
    // if (ids.length > 0) attachmentIds = ids.join(",");
    console.log("获取上传图的内容", attachmentIds, uploadedIds);
    const formData = new FormData();
    console.log("选中的原因", reasonName, subReasonName);
    formData.append("order_id", sessionStorage.getItem("order_name") || "");
    formData.append("order_item_id", orderItemId || "");
    formData.append("request_type", requestType); // 确保 requestType 在上文已定义
    formData.append("package_opened", itemStatus === "used" ? "1" : "0");
    formData.append("comment", comment);
    formData.append("reason", reasonName);
    formData.append("reason_sub", subReasonName);
    formData.append("carrier_code", carrierValue);
    formData.append("tracking_code", trackingValue);
    formData.append("print_label", printLabel || "");
    formData.append("is_apply_shipping_label", isApplyShippingLabel);
    formData.append("customer_email", customerId || "");
    if (uploadedIds && uploadedIds.length > 0) {
      formData.append("attachments", uploadedIds.join(","));
    }
    // if (attachmentIds) formData.append("attachments", attachmentIds);

    // 进行提交（await 在 async 函数里合法）
    // try {
    //   const res = await fetch(
    //     "https://plugin.kriyya.com/api/klaiyi/rma/order_store",
    //     {
    //       method: "POST",
    //       headers: { Authorization: "Bearer 6JXquydq6hZG4aJyN8A5" },
    //       body: formData,
    //     }
    //   );

    //   const data = await res.json();
    //   console.log("提交结果:", data);

    //   if (data.code == 200000) {
    //     window.location.href = "/pages/my-all-orders";
    //   } else {
    //     window.showErrorPopup(
    //       data.message || "Submission failed, please try again later"
    //     );
    //   }
    // } catch (err) {
    //   console.error("网络错误:", err);
    //   window.showErrorPopup("Network error, please try again later");
    // }
    try {
      const res = await fetch(
        "https://plugin.kriyya.com/api/klaiyi/rma/order_store",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
          },
          body: formData,
        }
      );

      // 1️⃣ HTTP 层失败（真正的失败）
      if (!res.ok) {
        throw new Error(`HTTP error: ${res.status}`);
      }

      // 2️⃣ JSON 可能为空或不完整
      const data = await res.json().catch(() => ({}));
      console.log("提交结果:", data);

      // 3️⃣ 明确成功
      if (data.code === 200000) {
        window.location.href = "/pages/my-all-orders";
        return;
      }

      // 4️⃣ 明确失败（后端明确告诉你失败）
      if (data.code && data.code !== 200000) {
        window.showErrorPopup(
          data.message || "Submission failed, please try again later"
        );
        return;
      }

      // 5️⃣ ⚠️ 没有 code / code 不存在 → 当作“处理中”

      window.location.href = "/pages/my-all-orders";
    } catch (err) {
      console.error("网络错误:", err);
      window.showErrorPopup("Network error, please try again later");
    }
  }

  // const getFiles = initFileUpload();
  // initRefundSubmit();
  // 底部textarea监听
  const textarea = document.getElementById("refund-description");
  const counter = document.getElementById("desc-count");

  if (textarea && counter) {
    textarea.addEventListener("input", function () {
      const length = textarea.value.length;
      counter.textContent = `${length}/1000`;
    });
  }
});

// 错误提示 + 红框
function showErrorMessage(selector, message) {
  const field = document.querySelector(selector);
  if (!field) return;

  const container = field.closest("div") || field.parentElement;
  if (!container) return;

  // =========================
  // ✅ 1. 特殊逻辑（优先级从高到低）
  // =========================

  // 👉 上传图片模块
  if (field.classList.contains("form-section-upload-pic")) {
    const target = field.querySelector(".upload-camera-btn");
    if (target) {
      target.classList.add("input-error");
    }
  }

  // 👉 物流信息模块
  else if (field.classList.contains("logistics-information-cen")) {
    const target = field.querySelector(".enter-ipt");
    if (target) {
      target.classList.add("input-error");
    }
  }

  // =========================
  // ✅ 2. 默认逻辑
  // =========================
  else {
    const inputs = field.querySelectorAll("input, select, textarea");

    if (inputs.length > 0) {
      inputs.forEach((el) => {
        el.classList.add("input-error");
      });
    } else {
      // 👉 没有 input 的兜底
      field.classList.add("input-error");
    }
  }

  // =========================
  // ✅ 3. 容器红框
  // =========================
  container.classList.add("input-error-wrap");

  // =========================
  // ✅ 4. 错误文案
  // =========================
  let errorEl = container.querySelector(".error-text");

  if (errorEl) {
    errorEl.textContent = message;
  } else {
    errorEl = document.createElement("div");
    errorEl.className = "error-text";
    errorEl.textContent = message;
    container.appendChild(errorEl);
  }
}
// 清除错误提示
function clearErrorMessage(selector) {
  const field = document.querySelector(selector);
  if (!field) return;

  const container = field.closest("div") || field.parentElement;

  // 上传图片模块
  if (field.classList.contains("form-section-upload-pic")) {
    const target = field.querySelector(".upload-camera-btn");
    if (target) target.classList.remove("input-error");
  }

  // 物流模块
  else if (field.classList.contains("logistics-information-cen")) {
    const target = field.querySelector(".enter-ipt");
    if (target) target.classList.remove("input-error");
  }

  // 默认
  else {
    const inputs = field.querySelectorAll("input, select, textarea");
    inputs.forEach((el) => el.classList.remove("input-error"));
    field.classList.remove("input-error");
  }

  container && container.classList.remove("input-error-wrap");

  const errorEl = container?.querySelector(".error-text");
  if (errorEl) errorEl.remove();
}
// 错误提示
// function showErrorMessage(selector, message) {
//   const field = document.querySelector(selector);
//   if (!field) return;

//   // 找到插入的容器
//   const container = field.closest("div") || field.parentElement;
//   if (!container) return;

//   // 检查是否已有错误提示
//   let errorEl = container.querySelector(".error-text");
//   if (errorEl) {
//     // 已存在则更新提示文字
//     errorEl.textContent = message;
//   } else {
//     // 不存在则新建
//     errorEl = document.createElement("div");
//     errorEl.className = "error-text";
//     errorEl.textContent = message;
//     container.appendChild(errorEl);
//   }
//   // const field = document.querySelector(selector);
//   // if (!field) return;

//   // // 如果是 input/select 元素，插入到其父元素后面
//   // const container = field.closest('div') || field.parentElement;
//   // const errorEl = document.createElement("div");
//   // errorEl.className = "error-text";
//   // errorEl.textContent = message;
//   // container.appendChild(errorEl);
// }
// 清除错误提示
// function clearErrorMessage(selector) {
//   console.log("进入清除错误提示", selector);
//   const container = document.querySelector(selector);
//   if (!container) return;

//   const errorEl = container.querySelector(".error-text");
//   if (errorEl) errorEl.remove();
// }
// --------- 换货弹窗函数 ----------
function showExchangePopup() {
  window.SurePopup?.open({
    title: "Contact Us",
    text: `
      Please provide detailed information about your request via email.<br><br>
      If you are requesting a return or exchange, please attach original photos of the item.<br><br>
      Email us: <a href="mailto:Klaiyi@klaiyihair.com">Klaiyi@klaiyihair.com</a>
    `,
    leftText: "Email Us",
    rightText: "Close",
    zIndex: 181,

    showClose: true,
    showMask: true,

    onConfirm() {
      window.location.href = "mailto:Klaiyi@klaiyihair.com";
    },

    onCancel() {
      window.SurePopup?.close();
      // 只关闭弹窗
    },
  });
}

// // ---------换货弹窗函数 ----------
// function showExchangePopup() {
//   const popup = document.querySelector(".sure-popup");
//   if (!popup) return;

//   // 修改弹窗标题
//   const titleSpan = popup.querySelector(".pop_title span");
//   if (titleSpan) titleSpan.textContent = "Contact Us";

//   // 修改弹窗内容
//   const wordEl = popup.querySelector(".sure-popup-main-word");
//   wordEl.innerHTML = `Please provide detailed information about your request via email.
//   If you are requesting a return or exchange, please attach original photos of the item.<br>
//   Email us: <a href="mailto:Klaiyi@klaiyihair.com">Klaiyi@klaiyihair.com</a>`;

//   // 修改按钮，只保留一个
//   const btnContainer = popup.querySelector(".sure_popup-btn");
//   btnContainer.innerHTML = `<a class="sure_popup-btn-right" href="mailto:Klaiyi@klaiyihair.com">Email Us</a>`;

//   // 设置按钮宽度为100%
//   const btn = btnContainer.querySelector(".sure_popup-btn-right");
//   if (btn) btn.style.width = "100%";

//   // 显示弹窗
//   popup.classList.remove("none");

//   // 设置遮罩显示
//   const mask = popup.querySelector(".window-cover");
//   mask.style.display = "block";

//   // 绑定关闭按钮
//   const btnClose = popup.querySelector(".icon-Close");
//   btnClose.addEventListener("click", function () {
//     popup.classList.add("none");
//     mask.style.display = "none"; // 隐藏遮罩
//   });

//   // 点击遮罩关闭
//   mask.addEventListener("click", function () {
//     popup.classList.add("none");
//     mask.style.display = "none"; // 隐藏遮罩
//   });
// }

async function order_status(rma_id) {
  try {
    // 构造 URL
    const url = new URL(
      "https://plugin.kriyya.com/api/klaiyi/rma/order_sub_status_list"
    );
    if (rma_id) {
      url.searchParams.set("rma_id", rma_id);
    }

    // 请求接口
    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5", // ⚠️ 替换成你自己的 Token
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      throw new Error(`接口请求失败，status=${res.status}`);
    }

    const resJson = await res.json();
    console.log("order_status 返回结果：", resJson);

    return resJson; // 把结果返回出去，方便调用方使用
  } catch (err) {
    console.error("获取订单状态失败：", err);
    return null;
  }
}

/**
 * 获取 RMA 订单商品详情
 * @param {Object} params - 参数对象
 * @param {string} params.order_name - 订单编号
 * @param {string|number} params.order_item_id - 订单项 ID
 * @param {string|number} params.order_productId - 产品 ID
 * @param {string|number} params.order_variant_id - 变体 ID
 * @param {string} params.customer_email - 客户邮箱
 * @returns {Promise<Object|null>} 返回接口数据或 null（请求失败时）
 */
async function getRmaOrderItemInfo(params = {}) {
  const {
    order_name,
    order_item_id,
    order_productId,
    order_variant_id,
    customer_email,
  } = params;

  try {
    const url = new URL(
      "https://plugin.kriyya.com/api/klaiyi/rma/order_item_info"
    );
    if (order_name) url.searchParams.set("order_id", order_name);
    if (order_item_id) url.searchParams.set("order_item_id", order_item_id);
    if (order_productId) url.searchParams.set("product_id", order_productId);
    if (order_variant_id) url.searchParams.set("variant_id", order_variant_id);
    if (customer_email) url.searchParams.set("customer_email", customer_email);

    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
    });

    if (!res.ok) {
      throw new Error(`接口请求失败，状态码：${res.status}`);
    }

    const json = await res.json();
    console.log("✅ RMA订单商品详情返回：", json);

    return json;
  } catch (err) {
    console.error("❌ 获取 RMA 订单商品详情失败：", err);
    return null;
  }
}
// 挂载到全局 window，使所有脚本都能用
window.getRmaOrderItemInfo = getRmaOrderItemInfo;

document.addEventListener("DOMContentLoaded", () => {
  const copyBtn = document.getElementById("copy-address");
  if (!copyBtn) return;

  copyBtn.addEventListener("click", () => {
    const textEl = copyBtn.closest(".copy-text").querySelector("p");
    if (!textEl) return;

    const text = textEl.textContent.trim();

    // 使用 Clipboard API 复制文本
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          window.utils.showCopyTip("Copied!");
        })
        .catch(() => {
          window.utils.showCopyTip("Copy failed!");
        });
    } else {
      // 兼容旧浏览器
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        window.utils.showCopyTip("Copied!");
      } catch (err) {
        window.utils.showCopyTip("Copy failed!");
      }
      document.body.removeChild(textarea);
    }
  });

  // 显示提示函数
  function showCopyTip(message) {
    let tip = document.createElement("div");
    tip.textContent = message;
    tip.style.position = "fixed";
    tip.style.top = "20px";
    tip.style.left = "50%";
    tip.style.transform = "translateX(-50%)";
    tip.style.background = "rgba(0,0,0,0.7)";
    tip.style.color = "#fff";
    tip.style.padding = "8px 16px";
    tip.style.borderRadius = "4px";
    tip.style.zIndex = "9999";
    tip.style.fontSize = "14px";
    tip.style.opacity = "0";
    tip.style.transition = "opacity 0.3s";

    document.body.appendChild(tip);

    // 动画显示
    requestAnimationFrame(() => {
      tip.style.opacity = "1";
    });

    // 1.5秒后自动消失
    setTimeout(() => {
      tip.style.opacity = "0";
      tip.addEventListener("transitionend", () => {
        tip.remove();
      });
    }, 1500);
  }
});

// 使用
// const rmaId = getQueryParam("rma_id");

// order_status(rmaId).then(data => {
//   if (data) {
//     console.log("订单子状态列表：", data.data);
//     // 子状态信息
//     const subStatus = data.data.rma_order_sub_status_info;
//     console.log('子状态信息', subStatus);

//     if (subStatus?.estimated_refund_amount) {
//       console.log('已经有价格');
//       // 设置到页面元素
//       const moneyEl = document.querySelector(".show-information-money");
//       if (moneyEl) {
//         moneyEl.textContent = subStatus.estimated_refund_amount; // 设置显示的值
//       }
//     }
//   }
// });
